import { BiAddToQueue } from 'react-icons/bi';
import Button from 'react-bootstrap/Button';

export function CreateButton({ children, ...rest }) {
    return (
        <Button variant="warning" size="sm" {...rest}>
          <BiAddToQueue/>
          {children}
        </Button>
    );
}
